import { IUpdateMultaJurosContratoUseCase } from "../../../presentation/useCases/update/update_multa_juros_contrato_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateMultaJurosContratoUseCase
 */

export class UpdateMultaJurosContratoUseCase implements IUpdateMultaJurosContratoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(
    idContratoFinanceiro: number,
    percentualJuros: number,
    percentualMulta: number
  ): Promise<void> {
    await this.repository.updateMultaJurosContrato(idContratoFinanceiro, percentualJuros, percentualMulta);
  }
}
